import { isNotDefined } from '@sgme/fp';
import { HStack } from '@sgme/ui';
import type { CustomCellRendererProps } from 'ag-grid-react';
import { useCallback } from 'react';

import { OpenInXoneButton } from '@/App/Blotter/grids/OpenInXoneButton.tsx';
import { RepriceQuoteButton } from '@/App/Blotter/grids/RepriceQuoteButton.tsx';
import { useTrackEvent } from '@/App/Blotter/useTrackEvent.ts';
import type { BlotterCashEntry } from '@/store/blotter/types/BlotterCashEntry.ts';
import { cashRepriceQuote } from '@/store/blotter/workflows/cashRepriceQuote/action';
import { useAppDispatch, useAppSelector } from '@/store/hooks.ts';

export const CommandsCellRenderer = ({ data: entry }: CustomCellRendererProps<BlotterCashEntry, string>) => {
  const dispatch = useAppDispatch();
  const currentTabId = useAppSelector((state) => state.tabs.activeTabId);

  const track = useTrackEvent();

  const onRepriceQuoteClick = useCallback(() => {
    if (isNotDefined(entry)) {
      return;
    }
    dispatch(cashRepriceQuote(entry, currentTabId));
    track('Reprice quote for cash', entry.id);
  }, [entry, currentTabId]);

  if (isNotDefined(entry) || isNotDefined(entry.product)) {
    return null;
  }

  return (
    <HStack horizontalAlignment="start">
      <OpenInXoneButton entry={entry} entryType="cash" />
      <RepriceQuoteButton entry={entry} onClick={onRepriceQuoteClick} />
    </HStack>
  );
};
